import {Component, DoCheck, OnDestroy, OnInit} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router, RoutesRecognized} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Subscription, filter, map} from 'rxjs';
import {ConfigService, DiagramSubtypeUrlMap} from '@q9elements/ui-kit/common';
import {AngularComponentService} from './diagram-render/mx-graph/graph/angular-component.service';
import {ResourceCommandService} from './commands/resource/resource.command.service';
import {DiagramUpdateService} from './diagram-data/diagram-update.service';
import {DiagramJsonHandlerService} from './diagram-data/diagram-json-handler.service';
import {environment} from '../environments/environment';
import {BoxHighlightService} from './diagram-interaction/services/box-highlight.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, DoCheck, OnDestroy {
  showLoader = !environment.NOUI;
  loading = true;
  public loadingCaption = '';
  public routerSubsription: Subscription;
  constructor(
    private iconsRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private compSvc: AngularComponentService,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private boxHL: BoxHighlightService,
    private route: ActivatedRoute,
    private router: Router,
    diagramUpdateSvc: DiagramUpdateService,
    resourceSvc: ResourceCommandService,
    private location: Location
  ) {
    diagramUpdateSvc.injectIntoResourceCommands();
    resourceSvc.injectIntoResourceCommands();
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.routerSubsription = this.router.events
      .pipe(
        filter(data => data instanceof RoutesRecognized && data.state.root.queryParams.copy_ref),
        map((data: RoutesRecognized) => data.state.root.queryParams.copy_ref)
      )
      .subscribe(copyRef => {
        if (copyRef) {
          this.loadingCaption = 'MAP_COPY.COPY_LOADING';
        }
      });

    this.icon('icon-paperclip', 'attachment');
    this.icon('icon-inform', 'information-icon');
    this.icon('icon-help', 'question');
    this.icon('icon-share', 'share');

    if (environment.NOUI) {
      this.icon('note');
      this.icon('link');
      this.icon('data-tables');

      return;
    }

    this.diagramJsonSvc.diagramJson$.subscribe(json => {
      const hlKey = this.route.snapshot.queryParams.hl;

      if (json.id) {
        this.loading = false;

        if (hlKey) {
          setTimeout(() => {
            this.boxHL.highlightBox(hlKey);
          });
        }

        this.addQueryParam('type', DiagramSubtypeUrlMap[json.subtype]);
      }
    });
  }

  ngDoCheck() {
    this.compSvc.runDetection();
  }

  ngOnDestroy(): void {
    this.routerSubsription.unsubscribe();
  }

  private icon(name: string, path?: string) {
    this.iconsRegistry.addSvgIcon(
      name,
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${ConfigService.environment.STATIC_FILES_URL}/icons/${path ?? name}.svg`
      )
    );
  }

  private addQueryParam(key: string, value: string) {
    if (this.route.snapshot.queryParams[key]) {
      return;
    }

    const currentParams = {...this.route.snapshot.queryParams, [key]: value};
    const path = this.location.path().split('?')[0];
    const queryString = new URLSearchParams(currentParams).toString();

    this.location.replaceState(`${path}?${queryString}`);
  }
}
